import { type Initiative } from '../models';
import RecordFilter from './RecordFilter';

class InitiativeFilter extends RecordFilter {
  matches(record: { initiative: Initiative }) {
    return super.matches(record.initiative);
  }
}

export default InitiativeFilter;
